import ShineBorder from 'components/magicui/ShineBorder'
import {SHINE_COLORS} from './gold'

/**
 * Magic UI's Shine Border in Sharpenny gold. Drop it as the first child
 * of any `relative` rounded card that holds coins: the reward popup, a
 * reward card, the wallet hero.
 */
const GoldShineBorder = ({duration = 10, borderWidth = 1, ...props}) => (
  <ShineBorder
    shineColor={SHINE_COLORS}
    duration={duration}
    borderWidth={borderWidth}
    {...props}
  />
)

export default GoldShineBorder
